@if (store.configurationError()) {
  <div class="config-error">
    <p>{{ 451856 | apmTranslate }}</p>
  </div>
} @else if (mainStore.isCompleted() && store.isCompleted()) {
  <div class="row">
    <div class="col-12 col-lg-4 d-flex flex-column filters-column">
      <div class="flex-grow-1 overflow-auto min-h-0">
        <apm-chiller-free-st-data-sheet-working-conditions />
      </div>
      <div class="flex-shrink-0 pt-3">
        <apm-button
          variant="secondary"
          [disabled]="!workingConditionsComp().isFormValid() || store.pdfLoading()"
          (buttonClick)="updateDatasheet()"
        >
          {{ 451855 | apmTranslate }}
        </apm-button>
      </div>
    </div>
    <div class="col-12 col-lg-8">
      <apm-chiller-free-st-data-sheet-preview />
    </div>
  </div>
}
